"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const ChallengeType_1 = require("../../enums/ChallengeType");
const fromEntries_1 = tslib_1.__importDefault(require("../../lib/fromEntries"));
const entries = Object.keys(ChallengeType_1.ChallengeType)
    .map((challengeType) => [challengeType, () => Promise.resolve().then(() => tslib_1.__importStar(require(`./${challengeType}`)))])
    .filter((x) => x);
exports.default = (0, fromEntries_1.default)(entries);
